

<template >
  <div id="user-info-card">
    <div class="user-info-card-info mb-5">
      <div class="info-section">
        <div class="section-header">
          <h2>API Keys</h2>
          <div class="place-holder"></div>
        </div>
        <div>
          <div class="row" style=" align-items: center;">
            <div class="col-md-8 input-group" style="flex-wrap:nowrap">
              <input disabled="true" class="update-input" :value="apikey" />
              <div class="input-group-append">
                <button
                  type="button"
                  class="btn color-btn"
                  style="margin-left: -3px"
                  v-clipboard:copy="apikey"
                  v-clipboard:success="onCopy"
                >
                  <v-icon style="height:24px" name="copy"></v-icon>
                  <div class="tooltip">
                    <span class="tooltiptext">Copy your Key</span>
                  </div>
                </button>
                <!-- <span class="input-group-text" id="basic-addon2">@example.com</span> -->
              </div>
            </div>
            <TerminalBasicButton
              class="ml-3 margin-top-sm"
              buttonText="Regenerate API Key"
              color="unibit-yellow"
              v-on:terminalBasicButtonClicked="regenerateKey"
            ></TerminalBasicButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import TerminalBasicButton from "@/components/base/terminal-basic-button";

export default {
  props: {},
  data() {
    return {};
  },

  components: {
    TerminalBasicButton
  },

  computed: mapState({
    apikey: state => state.UserService.apikey,
    loggedIn: state => state.UserService.idToken !== null
  }),

  methods: {
    regenerateKey() {
      const token = this.getWindowLocalStorage("token");
      this.$store
        .dispatch("regenerateAccessKey", { token })
        .then(res => {
          this.$store.commit("setUserApikey", res.data.apikey);
          this.setWindowLocalStorage("apikey", res.data.apikey);
          this.$notify({
            group: "note",
            title: "UniBit Account",
            text: "New Api Key Successfully Generated ",
            type: "success"
          });
        })
        .catch(err => {
          console.log(err.response);
          //   const message = "*" + err.response.data.message;
          //   this.keyInfo =
          //     message === "*Token Expired!"
          //       ? "You can only regenerage API key once per day!"
          //       : message;
          //   this.regenerateKeyStatus = false;
        });
    },

    onCopy() {
      this.$store.dispatch("notify", {
        info: "API Key Successfully Copied",
        type: "success"
      });
      // this.$notify({
      //       group: "note",
      //       title: "UniBit Account",
      //       text: "API Key Successfully Copied ",
      //       type: "success"
      //   });
    }
  }
};
</script>


<style lang="css" scoped>
* {
  font-family: Raleway;
  font-size: 0.875rem;
  /* font-weight: bold; */
  color: #656666;
  letter-spacing: 0.56px;
}

#user-info-card {
  background-color: white;
  height: 100%;
  overflow: auto;
}

.user-info-card-info {
  padding: 1rem;
}

.info-section {
  margin-bottom: 1rem;
}

.info-section h2 {
  /* font-size: 24px; */
  /* padding: 1rem 1.5rem; */
  font-weight: 600;
  margin: 0px;
  font-size: 1rem;
}

.color-btn {
  letter-spacing: 0.59px;
  color: #2f4552;
  background: #f5a623;
  font-weight: bold;
  white-space: normal;
  border: 1px solid #f5a623;
}

.icon-copy {
  color: white;
}

.update-input {
  font-size: 12px;
  border: solid 1px #979797;
  outline: 0;
  border-radius: 4px;
  width: 100%;
  padding: 13px 1rem;
  background: transparent;
}

.info-section > div {
  background-color: white;
  padding: 1rem 1.5rem;
}

.section-header {
  padding-bottom: 0 !important;
  margin-bottom: 2px;
  border-bottom: solid 0.4px rgba(151, 151, 151, 0.5);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.info-update {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.col-md-4 {
  margin-top: 3rem;
}

.place-holder {
  height: 2.5rem;
}

.margin-top-sm {
  margin-top: 1rem;
}

@media (min-width: 768px) {
  .col-md-4 {
    margin: 0px;
  }
}

@media only screen and (min-width: 992px) {
  * {
    font-size: 1rem;
    letter-spacing: 0.47px;
  }
  #user-info-card {
    padding: 3rem 45px;
  }

  .margin-top-sm {
    margin-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/card/apikey-info-card.vue